import { Grid } from '@mui/material';

import { ProjectVenueCardCarbonBudget } from './ProjectVenueCard/ProjectVenueCardCarbonBudget';
import { ProjectVenueCardDates } from './ProjectVenueCard/ProjectVenueCardDates';
import { ProjectVenueCardStructure } from './ProjectVenueCard/ProjectVenueCardStructure';

export function ProjectVenueCards({
  onClickOpenDates,
  onClickOpenStructure,
}: {
  onClickOpenDates: () => void;
  onClickOpenStructure: () => void;
}) {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6} lg={4}>
        <ProjectVenueCardStructure
          onClickOpenStructure={onClickOpenStructure}
        />
      </Grid>
      <Grid item xs={12} md={6} lg={4}>
        <ProjectVenueCardDates onClickOpenDates={onClickOpenDates} />
      </Grid>
      <Grid item xs={12} md={6} lg={4}>
        <ProjectVenueCardCarbonBudget />
      </Grid>
    </Grid>
  );
}
